import image1 from "./ACLAS-LOGO.png";
import image2 from "./ADVANTECH-LOGO.png";
import image3 from "./ARGOX-LOGO.png";
import image4 from "./BLUEBIRD-LOGO.png";
import image5 from "./CUSTOM-LOGO.png";
import image6 from "./HANASIS-LOGO.png";
import image7 from "./HID-LOGO.png";
import image8 from "./POINT-MOBILE-LOGO.png";
import image9 from "./POINTTAB--LOGO.png";
import image10 from "./POSBANK-LOGO.png";
import image11 from "./SPENTA-LOGO.png";
import image12 from "./sewoologo.png";

export const Brands = [
  image1,
  image2,
  image3,
  image4,
  image5,
  image6,
  image7,
  image8,
  image9,
  image10,
  image11,
  image12,
];
